<script lang="ts">
  import { formatTime } from '../utils/formatters';
  
  export let elapsedSeconds: number = 0;
  export let isRunning: boolean = false;
</script>

<div class="flex flex-col items-center justify-center gap-3 w-full">
  <div class="text-4xl md:text-6xl lg:text-7xl font-mono font-bold text-custom dark:text-white drop-shadow-lg text-center break-all">
    {formatTime(elapsedSeconds)}
  </div>
  {#if isRunning}
    <div class="flex items-center gap-2 text-green-custom dark:text-green-400">
      <div class="w-3 h-3 bg-green-custom dark:bg-green-400 rounded-full animate-pulse"></div>
      <span class="text-sm font-medium">Running</span>
    </div>
  {/if}
</div>

<style>
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  
  .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
</style>
